/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbSmsUtilitaireGridDto } from './FcbSmsUtilitaireGridDto';
import {
    FcbSmsUtilitaireGridDtoFromJSON,
    FcbSmsUtilitaireGridDtoFromJSONTyped,
    FcbSmsUtilitaireGridDtoToJSON,
} from './FcbSmsUtilitaireGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbSmsUtilitaireGridDtoPaginatedResults
 */
export interface FcbSmsUtilitaireGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbSmsUtilitaireGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbSmsUtilitaireGridDto>}
     * @memberof FcbSmsUtilitaireGridDtoPaginatedResults
     */
    results?: Array<FcbSmsUtilitaireGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbSmsUtilitaireGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbSmsUtilitaireGridDtoPaginatedResults interface.
 */
export function instanceOfFcbSmsUtilitaireGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSmsUtilitaireGridDtoPaginatedResultsFromJSON(json: any): FcbSmsUtilitaireGridDtoPaginatedResults {
    return FcbSmsUtilitaireGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbSmsUtilitaireGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSmsUtilitaireGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbSmsUtilitaireGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbSmsUtilitaireGridDtoPaginatedResultsToJSON(value?: FcbSmsUtilitaireGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbSmsUtilitaireGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

